// D3 special pleat surcharge - imported by calculatePleat.js

export function calculateD3(totalWidths, COM) {
      console.log('calculateD3() start');

      if (COM == true) {
            switch (totalWidths) {
                  case 1:
                        return 98;
                  case 2:
                        return 196;
                  case 3:
                        return 295;
                  case 4:
                        return 393;
                  case 5:
                        return 491;
                  case 6:
                        return 589;
                  case 7:
                        return 687;
                  case 8:
                        return 785;
                  case 9:
                        return 884;
                  case 10:
                        return 982;
                  default:
                        console.log('- totalWidths out of scope');
                        return 0;
            }
      } else if (COM == false) {
            switch (totalWidths) {
                  case 1:
                        return 85;
                  case 2:
                      return 171;
                  case 3:
                      return 256;
                  case 4:
                      return 342;
                  case 5:
                      return 427;
                  case 6:
                      return 512;
                  case 7:
                      return 598;
                  case 8:
                      return 683;
                  case 9:
                      return 768;
                  case 10:
                      return 854;
                  default:
                        console.log('- totalWidths out of scope');
                        return 0;
            }
      } else {
            console.log('- COM is null');
      }
}